import React from "react";
import Loader from "../loader";
import dltBtn from "../../static/svg/delete.svg";

const ModalWithInput = (props) => {
  const { 
    close, desc, doAction, disable, isLoading, disableStatus, buttonText = "Submit",
    inputData, setInputData, required = false, inputLabel = "", inputPlaceholder = ""
  } = props;

  return (
    <div className="full-page-overlay">
      <div className="flex-container full-height vertical-middle">
        <div className="template-uploader">
          <div className="modal-body relative">
            <div className="heading less-margin">Are you sure?</div>
            {!isLoading &&
              <div
                className="close"
                onClick={() => close(false)}
              >
                <img src={dltBtn} alt="close" />
              </div>
            }
            <p className="sub-heading">{desc}</p>
            <div className="form-group has-field">
              <label htmlFor="input-data">{inputLabel}{required && <span>*</span>}</label>
              <textarea
                type="text"
                id="input-data"
                className="input-field"
                placeholder={inputPlaceholder}
                autoComplete="off"
                onChange={(e) => setInputData(e.target.value)}
                required={required ? "required" : ""}
                value={inputData}
                disabled={disableStatus}
              />
            </div>
            <div className="footer flex-container no-margin flex-end">
              <button
                className="btn"
                disabled={isLoading}
                onClick={() => close(false)}
              >Cancel</button>
              <button
                className="btn flex moral"
                disabled={(required && !inputData) || disableStatus}
                onClick={() => {
                  disable(true);
                  doAction();
                }}
              >
                {isLoading && <Loader/>}
                {buttonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default ModalWithInput;
